/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthenticationStrictHttpResponse } from '../../authentication-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface LocalAccountRequestAccountLinkPost$Params {
}

export function localAccountRequestAccountLinkPost(http: HttpClient, rootUrl: string, params?: LocalAccountRequestAccountLinkPost$Params, context?: HttpContext): Observable<AuthenticationStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, localAccountRequestAccountLinkPost.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthenticationStrictHttpResponse<string>;
    })
  );
}

localAccountRequestAccountLinkPost.PATH = '/LocalAccount/RequestAccountLink';
